import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

let expansionPanelUniqueId = 0;

@Component({
  selector: 'app-expansion-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.css',
})
export class ExpansionPanelComponent implements OnChanges {
  @Input() title = '';

  @Input() collapsed = false;

  @Input() disabled = false;

  @Input() showChevron = true;

  @Output() collapsedChange = new EventEmitter<boolean>();

  @Output() toggled = new EventEmitter<boolean>();

  isCollapsed = false;

  readonly contentId = `expansion-panel-content-${expansionPanelUniqueId++}`;

  ngOnChanges(changes: SimpleChanges): void {
    if ('collapsed' in changes) {
      this.isCollapsed = this.collapsed;
    }
  }

  toggle(): void {
    if (this.disabled) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
    this.toggled.emit(this.isCollapsed);
  }
}
